'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'rocket-launch';
var width = 512;
var height = 512;
var aliases = [128640];
var unicode = 'e027';
var svgPathData = 'M219.3 292.7c-10-10-21.4-18.1-33.8-24.1C217.8 137.7 276.6 78.5 332.6 52.2c50.3-23.6 103.3-23 143.1-15.9c7 39.8 7.7 92.8-15.9 143.1c-26.3 55.9-85.5 114.8-216.4 147.1c-6-12.4-14.1-23.9-24.1-33.8zM256 381.3c0-8.2-.8-16.3-2.4-24.3c37.8-9.5 70.4-21.3 98.4-34.7l0 91.9-96 48 0-80.9zM384 424l0-119C527.5 217.9 520.4 80.2 502.7 9.3C431.8-8.4 294.1-15.5 207.1 128L88 128l-9.9 0-4.4 8.8-64 128L-1.9 288 24 288l106.7 0c24.7 0 48.5 9.8 65.9 27.3s27.3 41.2 27.3 65.9L224 488l0 25.9 23.2-11.6 128-64 8.8-4.4 0-9.9zM155 258.4c-7.9-1.6-16.1-2.4-24.3-2.4l-80.9 0 48-96 91.9 0c-13.5 28-25.2 60.5-34.7 98.4zm-11.2 189c-16.6 16.6-48.4 26.1-82.7 30.2c-10.4 1.2-20.3 1.9-28.9 2.2c.3-8.6 1-18.5 2.2-28.9c4.1-34.3 13.6-66.2 30.2-82.7c21.9-21.9 57.4-21.9 79.3 0s21.9 57.4 0 79.3zM166.5 470c34.4-34.4 34.4-90.1 0-124.5s-90.1-34.4-124.5 0C-7.5 395 .5 511.5 .5 511.5s116.5 8 166-41.5zM392 144a24 24 0 1 1 -48 0 24 24 0 1 1 48 0zM368 88a56 56 0 1 0 0 112 56 56 0 1 0 0-112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRocketLaunch = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;